import '../DeckNav.css';
import { ColorsDeckFace} from '../../DeckCardOverviews/BasicWords/ColorsOv';
import DeckNav from '../DeckNav';
import HeaderNav from '../../Components/Header/Header_Nav/Header_Nav';
//one folder up so use ../
//if two folders away use ../../
import SPLoader from '../../Components/Spinner/SpinnerLoader';
import ResourceBar from '../../Components/Resource/ResourceBar';
import Footer from '../../Components/Footer/Footer';

export default function ColorsNav() {
  return (
<div>
  <SPLoader time={0.2}/>
  <HeaderNav GoBack_to={"/BasicWordsNav"}/>
  <h1 className="DeckTitle-nav">Colors (색깔)</h1>
  <ResourceBar DeeperLook_to="/ColorsDLook" Dictionary_to="/ColorsDictionary"/>
  <h1 className="Header2-nav">Flashcards</h1>
   <div><DeckNav faceCard={ColorsDeckFace} title_input=""/> </div>
   <Footer/>
</div>
  )
}